import { createTheme } from '@mui/material/styles';

const transitionEase = {
  base: 'cubic-bezier(0.78,-0.03,0.33,0.75)',
};

// A custom theme for this app
let theme = createTheme({
  typography: {
    fontFamily: ['Lato', 'Arial', 'sans-serif'].join(','),
  },
});
theme = createTheme(theme, {
  typography: {
    h1: {
      fontSize: '4rem',
      lineHeight: '5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '1.75rem',
      lineHeight: '2.5rem',
      fontWeight: 600,
      [theme.breakpoints.up('md')]: {
        fontSize: '3rem',
        lineHeight: '4rem',
      },
    },
    h3: {
      fontSize: '1.5rem',
      lineHeight: '2rem',
      fontWeight: 600,
      [theme.breakpoints.up('sm')]: {
        fontSize: '2rem',
        lineHeight: '2.5rem',
      },
    },
    h4: {
      fontSize: '1.25rem',
      lineHeight: '1.875rem',
      fontWeight: 600,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
      },
    },
    h5: {
      fontSize: '1rem',
      lineHeight: '1.5rem',
      fontWeight: 600,
      [theme.breakpoints.up('sm')]: {
        fontSize: '1.125rem',
        lineHeight: '1.625rem',
      },
    },
    subtitle1: {
      fontSize: '1.125rem',
      lineHeight: '1.5rem',
      fontWeight: 400,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.25,
      fontWeight: 400,
    },
    display: {
      fontSize: '2rem',
      lineHeight: '2.5rem',
      fontWeight: 600,
      [theme.breakpoints.up('sm')]: {
        lineHeight: '3.375rem',
        fontSize: '2.875rem',
      },
    },
  },
  palette: {
    primary: {
      main: '#fed100',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          lineHeight: '1.25',
          fontWeight: 600,
          padding: '0.875rem 2.5rem',
          borderRadius: '0.375rem',
          backgroundColor: '#000000',
          color: '#ffffff',
        },
      },
    },
  },
});

declare module '@mui/material/styles' {
  interface TypographyVariants {
    display: React.CSSProperties;
  }

  // allow configuration using `createTheme`
  interface TypographyVariantsOptions {
    display?: React.CSSProperties;
  }
}

// Update the Typography's variant prop options
declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    display: true;
  }
}

export default theme;
